import { useEffect, useRef, useState } from 'react'

interface ShareButtonProps {
  boletin: string
}

export function ShareButton({ boletin }: ShareButtonProps) {
  const [copied, setCopied] = useState(false)
  const resetTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  // Clean up pending reset timer on unmount
  useEffect(() => {
    return () => {
      if (resetTimerRef.current !== null) {
        clearTimeout(resetTimerRef.current)
      }
    }
  }, [])

  function handleClick(ev: React.MouseEvent) {
    ev.stopPropagation()
    ev.preventDefault()

    const origin = window.location.origin || 'https://hemiciclo.cl'
    const url = `${origin}/proyecto/${boletin}`

    navigator.clipboard.writeText(url).then(() => {
      setCopied(true)
      if (resetTimerRef.current !== null) {
        clearTimeout(resetTimerRef.current)
      }
      resetTimerRef.current = setTimeout(() => {
        setCopied(false)
        resetTimerRef.current = null
      }, 2000)
    }).catch(() => {
      // Ignore clipboard failures (e.g. non-HTTPS contexts)
    })
  }

  const ariaLabel = copied ? 'Enlace copiado' : 'Copiar enlace'
  const titleAttr = copied ? 'Enlace copiado' : 'Copiar enlace'

  return (
    <button
      type="button"
      className={`share-button${copied ? ' share-button--copied' : ''}`}
      aria-label={ariaLabel}
      title={titleAttr}
      onClick={handleClick}
    >
      {copied ? (
        <svg
          viewBox="0 0 20 20"
          width="14"
          height="14"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M4 10.5l4 4 8-8" />
        </svg>
      ) : (
        <svg
          viewBox="0 0 20 20"
          width="14"
          height="14"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M8.5 11.5a3 3 0 0 0 4.24 0l2.83-2.83a3 3 0 1 0-4.24-4.24l-0.7 0.7" />
          <path d="M11.5 8.5a3 3 0 0 0-4.24 0l-2.83 2.83a3 3 0 1 0 4.24 4.24l0.7-0.7" />
        </svg>
      )}
    </button>
  )
}
